import { useCallback, useRef, useState } from 'react'

export function useElementHeight(minimumHeight = 0) {
    const [height, setHeight] = useState(minimumHeight)
    const observer = useRef<ResizeObserver | null>(null)
    const ref = useCallback((element: HTMLDivElement | null) => {
        observer.current?.disconnect()
        observer.current = null
        if (!element) return

        const updateHeight = () => setHeight(Math.max(minimumHeight, Math.ceil(element.getBoundingClientRect().height)))
        updateHeight()
        if (typeof ResizeObserver !== 'undefined') {
            observer.current = new ResizeObserver(updateHeight)
            observer.current.observe(element)
        }
    }, [minimumHeight])

    return { ref, height }
}
